import { Directive, ElementRef, HostListener, HostBinding, Output, EventEmitter, Renderer2, OnInit, OnDestroy, TemplateRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[directive-drop-down]',
})
export class DropDownDirective implements OnInit, OnDestroy, OnChanges {
    private _listener: () => void;
    private _lockClick: boolean = false;
    private _trigger: HTMLElement;

    @Input() public trigger: TemplateRef<any>;
    @Input() public openEvent: string = 'click';
    @Input() public projection: 'local' | 'global';
    @Input() public closeGlobalOnScroll: boolean = true;
    @Input() public open!: boolean;

    @Output() public onToggle: EventEmitter<boolean> = new EventEmitter();
    @HostBinding('class.is-active') private _isOpen: boolean = false;

    constructor(
        private _elementRef: ElementRef,
        private _renderer2: Renderer2,
    ) { }

    ngOnInit(): void {
        this._trigger = this.trigger.elementRef.nativeElement.parentElement.firstElementChild || this._elementRef.nativeElement.previousElementSibling;

        if (this.openEvent) {
            this._listener = this._renderer2.listen(this._trigger, this.openEvent, this._triggerClickHandler.bind(this));
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.openEvent && changes?.open && typeof changes?.open?.currentValue === 'boolean' && changes?.open?.currentValue !== changes?.open?.previousValue) {
            this._requestLockClick();
            this._isOpen = changes.open.currentValue;
            this.onToggle.emit(this._isOpen);
        }
    }

    ngOnDestroy(): void {
        if (this._listener) {
            this._listener();
        }
    }

    private _requestLockClick(): void {
        this._lockClick = true;
        setTimeout(() => { this._lockClick = false; }, 0);
    }

    private _triggerClickHandler(): void {
        this._requestLockClick();
        this._isOpen = !this._isOpen;

        this.onToggle.emit(this._isOpen);
    }

    @HostListener('click', ['$event']) public onHostClick(): void {
        this._requestLockClick();
        this._isOpen = !this._isOpen; /* This will close dd when option selected... might need some extra config */
        this.onToggle.emit(this._isOpen);
    }

    @HostListener('document:click', ['$event']) public onOutsideClick($event: Event): void {
        this.handleOutsideClicke($event);
    }

    @HostListener('window:drop-down:outer-click', ['$event']) public onOutsideElementWithStopPropagationClicked($event: Event): void {
        this.handleOutsideClicke($event);
    }

    @HostListener('window:scroll', ['$event']) public handleOnScrollBehavior($event: Event): void {
        if (this.projection === 'global' && this.closeGlobalOnScroll && this._isOpen) {
            this._requestLockClick();
            this._isOpen = !this._isOpen; /* This will close dd when option selected... might need some extra config */
            this.onToggle.emit(this._isOpen);
        }
    }

    public handleOutsideClicke($event: Event): void {
        if (this._lockClick) { return; }
        this._isOpen = false;
        this.onToggle.emit(this._isOpen);
    }
}
